<template>
  <div>
    <h2 class="border-none">Which of the interests that you previously selected would you be comfortable talking about?</h2>
    <div>
      <div class="spacer-b-2 lead-text">Specialist topics will increase your chance of being shortlisted for</div>
      <div class="flex flex-row flex-wrap gray-500 w-2/3 justify-between">
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-microphone"></i></div> Guest Speaking</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-laptop"></i></div> Q&A</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-bar-chart"></i></div> Keynotes</div>
        <div class="info-item"><div class="w-2/10 flex justify-center align-center"><i class="fa fa-comments"></i></div> Social Media Campaigns</div>
      </div>
      <div class="spacer-t-5 lead-text">Select all the specialist topics which apply</div>
      <div v-if="!selectedCategories || (selectedCategories && !selectedCategories.length)" class="flex justify-center spacer-y-2 spacer-x-2 margin-y-2 text-center" style="background-color: white;">
        <div><router-link :to="{ params: { page: 'interests' }, query: this.$route.query }">Add interests</router-link>&nbsp;from our list or suggest your own below.</div>
      </div>
      <div class="w-full flex flex-wrap">
        <div
          v-for="category in selectedCategories"
          :key="category.id"
          class="category"
          :class="category.type === 'specialist' ? 'category--selected' : ''"
          @click="$emit('toggled', category.id, category.group, category.name)">
          <i class="fa" :class="category.type === 'specialist' ? 'fa-check' : 'fa-plus'"></i>
          {{ category.name }}
        </div>
      </div>
      <div class="spacer-t-5" v-if="customCategories && customCategories.length">Under review</div>
      <div class="w-full flex flex-wrap">
        <div
          v-for="category in customCategories"
          :key="category.id"
          class="category"
          :class="category.type === 'specialist' ? 'category--selected' : ''"
          @click="$emit('toggled', category.id)">
          <i class="fa" :class="category.type === 'specialist' ? 'fa-check' : 'fa-plus'"></i>
          {{ category.name }}
        </div>
      </div>
    </div>
    <div>
      <div class="margin-y-2 lead-text">Any other specialist topics you would like to talk about?</div>
      <search-picker
        :full-width="true"
        :with-icon="true"
        :with-popper="true"
        :get-data="getInterestCategories"
        @selected="(option) => { $emit('selected', option) }"
        :current="selectedCategories"
        placeholder="Add topic">
        <template v-slot:list-item-content="{ option }">
          <div
            v-if="option.group"
            class="search-picker__subtext">
            <span>{{ option.group }}</span>
          </div>
        </template>
      </search-picker>
    </div>
  </div>
</template>

<script>
import TagPicker from '../misc/TagPicker'
import SearchPicker from '../misc/SearchPicker'
import { http } from 'utils'
export default {
  components: { TagPicker, SearchPicker },
  props: {
    interestCategories: {
      required: true
    },
    customCategories: {
      required: true
    },
    selectedCategories: {
      required: true
    }
  },

  methods: {
    async getInterestCategories (params) {
      const response = await http.get('interest-categories', { params })
      return response.data.data
    }
  }
}
</script>
